import { JsonObject } from '../../helpers';
import {
  ClassifierConfig,
  ClassifierModel,
  ClassifierSubType,
  ClassifierType,
} from './classifier.model';

export class RegexClassifierModel extends ClassifierModel {
  config: ClassifierConfig;

  constructor(props: JsonObject = {}) {
    super(props);

    this.config = (props.config as ClassifierConfig) || { pattern: '' };

    if (!this.type) {
      this.type = ClassifierType.Custom;
    }
    if (!this.subtype) {
      this.subtype = ClassifierSubType.Regex;
    }
  }
}
